import UserRepository from "../repository/UserRepository";

export default class UserService {
    constructor() {
        this.repository = new UserRepository();
    }

    getUsers() {
        return new Promise((resolve) => {
            this.repository.getAllUsers((x) => {
                resolve(x);
            });
        })
    }

    getUserByEmail(email) {
        let user = {};
        this.repository.getAllUsers(function(data) {
            user = data.find((u) => { return u.playerparentemail === email })
        });
        return user;
    }

    getUserById(id) {
        let user = {};
        this.repository.getOneUser(id, function(data) {
            user = data;
        });
        return user;
    }

    createUser(modelData) {
        this.repository.createUser(modelData);
    }

    updateUser(id, modelData) {
        this.repository.updateUser(id, modelData);
    }
    
}